module.exports = __webpack_public_path__ + "img/3.bfbd539a.jpg";